import React, {Component} from "react";

const Banner = ()=>{
    return (
        <div></div>
    //    <div className="row">
    //    <div className='col' style={{
    //        padding: 10,
    //        backgroundColor: "rgb(0, 88, 161)",
    //        color: "white",
    //        marginLeft: 15,
    //        marginBottom: 1
    //    }}>
    //        <p><b>Important Notice: Scheduled Upgrade and Maintenance</b></p>
    //        <p>Kluwer Law Online might experience temporary interruptions on Thursday, 23 October 2025, from 15:00 CET until 19:00 CET due to scheduled maintenance. The maintenance is expected to last approximately one hour, but services may be unavailable longer. We apologize for any inconvenience this may cause and thank you for your understanding.
    //        </p>
    //    </div>
    // </div>
    )
}

export default Banner;



// WEBPACK FOOTER //
// ./src/components/Banner.jsx